import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

const TAG = '[Spaycial Integration]';


export const loadStatus = createAction(`${TAG} Load status`);
export const loadStatusSuccess = createAction(`${TAG} Status loaded`, props<{ active: boolean; scanUser: boolean }>());
export const loadStatusFailure = createAction(`${TAG} Status load failed`, props<{ error: HttpErrorResponse }>());

export const connect = createAction(`${TAG} Connect`, props<{ callbackUrl?: string }>());
export const connectSuccess = createAction(`${TAG} Connected`, props<{ redirectUrl: string }>());
export const connectFailure = createAction(`${TAG} Connect failure`, props<{ error: HttpErrorResponse }>());

export const loadConnections = createAction(`${TAG} Load connections`, props<{ callbackUrl: string }>());
export const loadConnectionsSuccess = createAction(`${TAG} Connections loaded`, props<{ redirectUrl: string }>());
export const loadConnectionsFailure = createAction(`${TAG} Connections load failed`, props<{ error: HttpErrorResponse }>());

export const loadActivities = createAction(`${TAG} Load activities`, props<{ callbackUrl: string }>());
export const loadActivitiesSuccess = createAction(`${TAG} Activities loaded`, props<{ redirectUrl: string }>());
export const loadActivitiesFailure = createAction(`${TAG} Activities load failed`, props<{ error: HttpErrorResponse }>());

export const disconnect = createAction(`${TAG} Disconnect`);
export const disconnectSuccess = createAction(`${TAG} Disconnected`);
export const disconnectFailure = createAction(`${TAG} Disconnect failure`, props<{ error: HttpErrorResponse }>());

export const loadProfile = createAction(`${TAG} Load profile`, props<{ callbackUrl?: string }>());
export const loadProfileSuccess = createAction(`${TAG} Profile loaded`, props<{ redirectUrl: string }>());
export const loadProfileFailure = createAction(`${TAG} Profile load failed`, props<{ error: HttpErrorResponse }>());

export const loadOffers = createAction(`${TAG} Load offers`, props<{ callbackUrl?: string }>());
export const loadOffersSuccess = createAction(`${TAG} Offers loaded`, props<{ redirectUrl: string }>());
export const loadOffersFailure = createAction(`${TAG} Offers load failed`, props<{ error: HttpErrorResponse }>());

export const resetError = createAction(`${TAG} Reset error`);
export const resetRedirectUrl = createAction(`${TAG} Reset redirect`);
